import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, Typography } from "@mui/material";
import VendorRequest from "components/Admin/VendorRequest";
import DialogApprove from "components/Admin/DialogApprove";
import DialogRequestApproved from "components/Admin/DialogRequestApproved";
import { VendorApi } from "stores/VendorStore/vendoApi";
import DialogRejectApproved from "components/Admin/DialogRejectApproved";
import DialogReject from "components/Admin/DialogReject";

class VendorRequestContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      opendistance: false,
      openreject: false,
      open: false,
      openR: false,
      approve_status: true,
      vendor_Id: "",
    };
  }

  componentDidMount() {
    this.props.getVendorRequestAction();
  }

  handleDistanceClickOpen = (id, index) => {
    this.setState({ opendistance: true, vendor_Id: id });
  };
  handleRejectClickOpen = (id, index) => {
    this.setState({ openreject: true, vendor_Id: id });
  };

  handleSubmitApproved = async () => {
    let id = this.state.vendor_Id;
    // let status = this.state.approve_status;
    let res = await VendorApi.postApproveRequestApi(id, 1);
    this.setState({ opendistance: false });
    await this.props.getVendorRequestAction();
    if (res.status === 1) {
      this.handleClickOpen();
    }
  };

  handleSubmitRejectVendor = async () => {
    let id = this.state.vendor_Id;
    // let status = this.state.approve_status;
    let res = await VendorApi.postRejectRequestApi(id, 0);
    this.setState({ openreject: false });
    await this.props.getVendorRequestAction();
    if (res.status === 1) {
      this.handleClickOpenReject();
    }
  };

  handleCloseReject = () => {
    this.setState({ openR: false });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClickOpenReject = () => {
    this.setState({ openR: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCloseDialogereject = () => {
    this.setState({ openreject: false });
  };

  handleCloseDialoge = () => {
    this.setState({ opendistance: false });
  };
  render() {

    const request = this.props?.VendorRequestList?.result?.pending_vendor_list;
    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/vendor "
            >
              Vendor
            </Link>
            <Typography sx={{ fontSize: "14px" }} color=" #0DA861">
              Requests
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <VendorRequest
              data={request}
              handleDistanceClickOpen={this.handleDistanceClickOpen}
              handleRejectClickOpen={this.handleRejectClickOpen}
            />
          </Paper>
        </Grid>

        <DialogApprove
          handleSubmitApproved={this.handleSubmitApproved}
          open={this.state.opendistance}
          handleCloseDialoge={this.handleCloseDialoge}
          onClickModel={this.handleClickOpen}
        />
        <DialogRequestApproved
          handleClose={this.handleClose}
          open={this.state.open}
        />

        <DialogRejectApproved
          handleClose={this.handleCloseReject}
          open={this.state.openR}
        />

        <DialogReject
          handleSubmitRejectVendor={this.handleSubmitRejectVendor}
          open={this.state.openreject}
          handleCloseDialoge={this.handleCloseDialogereject}
          onClickModel={this.handleClickOpenReject}
        />
      </Grid>
    );
  }
}
export default VendorRequestContainer;
